export const rolesQueryKeys = {
  getRoles: () => ['roles'] as const
}

export const rolesMutationKeys = {
  createRole: () => ['roles', { method: 'post' }] as const,
  deleteRole: (roleId: string) =>
    [`roles/${roleId}`, { method: 'delete' }] as const,
  updateRole: (roleId: string) =>
    [`roles/${roleId}`, { method: 'patch' }] as const
}
